<div class="assistant-page" testId="assistant-management-page">
  <div class="page-topbar" testId="assistant-management-topbar">
    <div class="page-header" testId="assistant-management-header">
      <div class="page-heading" testId="assistant-management-heading">
        <h2 testId="assistant-management-title">{{ 'assistant.management.title' | i18n }}</h2>
        <p testId="assistant-management-subtitle">{{ 'assistant.management.subtitle' | i18n }}</p>
      </div>
    </div>

    <div class="assistant-store-tabs" role="tablist" [attr.aria-label]="'assistant.management.store.tabs.aria-label' | i18n">
      <button
        type="button"
        [class.is-active]="assistantStoreView() === 'mine'"
        (click)="selectAssistantStoreView('mine')"
        testId="assistant-management-tab-mine"
        >{{ 'assistant.management.tab.mine' | i18n }}</button
      >
      <button
        type="button"
        [class.is-active]="assistantStoreView() === 'instances'"
        (click)="selectAssistantStoreView('instances')"
        testId="assistant-management-tab-instances"
        >{{ 'assistant.management.store.tab.instances' | i18n }}</button
      >
      <button
        type="button"
        [class.is-active]="assistantStoreView() === 'market'"
        (click)="selectAssistantStoreView('market')"
        testId="assistant-management-tab-market"
        >{{ 'assistant.management.tab.market' | i18n }}</button
      >
    </div>
  </div>

  <assistant-mine-view *ngIf="assistantStoreView() === 'mine'" [vm]="viewModel" />
  <!-- Keep the instance-detail overlay host mounted so marketplace cards can open an existing instance directly. -->
  <assistant-instances-view [vm]="viewModel" />
  <!-- Keep the marketplace overlay host mounted so renew/purchase modals also work from the instances tab. -->
  <assistant-market-view [vm]="viewModel" />
</div>
